import { computed, input } from '@angular/core';
import { Marked } from 'marked';
import { INCOMPLETE_MARKDOWN_LINK_REGEX, MARKDOWN_RENDERER_OPTIONS } from 'AIChatApp/constants/ai-chat.constant';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import * as i0 from "@angular/core";
function AgentResponseMessageComponent_For_4_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr");
} }
function AgentResponseMessageComponent_For_4_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "a", 5);
    i0.ɵɵelement(3, "span", 6);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const action_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", action_r1.display_result.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", action_r1.display_result.title);
} }
function AgentResponseMessageComponent_For_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, AgentResponseMessageComponent_For_4_Conditional_0_Template, 1, 0, "hr")(1, AgentResponseMessageComponent_For_4_Conditional_1_Template, 4, 2, "div", 3);
} if (rf & 2) {
    const action_r1 = ctx.$implicit;
    const $index_r2 = ctx.$index;
    i0.ɵɵconditional($index_r2 === 0 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(action_r1.display_result ? 1 : -1);
} }
const marked = new Marked({ renderer: { ...MARKDOWN_RENDERER_OPTIONS } });
export class AgentResponseMessageComponent {
    constructor() {
        this.messageText = input.required();
        this.displayActions = input([]);
        this.messageHtml = computed(() => {
            const cleanedContent = this.messageText().replace(INCOMPLETE_MARKDOWN_LINK_REGEX, '*Creating Link...*');
            return marked.parse(cleanedContent);
        });
    }
}
AgentResponseMessageComponent.ɵfac = function AgentResponseMessageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentResponseMessageComponent)(); };
AgentResponseMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentResponseMessageComponent, selectors: [["ycn-agent-response-message"]], inputs: { messageText: [1, "messageText"], displayActions: [1, "displayActions"] }, decls: 5, vars: 1, consts: [[1, "pt-3", "pr-20", "pb-3", "pl-20", "bg-white", "rounded-4"], [1, "section-ai-response-content"], [1, "ai-md", 3, "innerHTML"], [1, "section-ai-response-link", "mb-2"], [1, "d-flex"], ["target", "_blank", 1, "text-underline", "text-blue", 3, "href"], [1, "text-nowrap", 3, "textContent"]], template: function AgentResponseMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "div", 2);
        i0.ɵɵrepeaterCreate(3, AgentResponseMessageComponent_For_4_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIndex);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("innerHTML", ctx.messageHtml(), i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance();
        i0.ɵɵrepeater(ctx.displayActions());
    } }, dependencies: [IconModule], encapsulation: 2, changeDetection: 0 });
